import axios from 'axios';

const state = {
    all: {}
};

const mutations = {
    load(state, permissions){
        for(const permission of permissions){
            state.all[permission.id] = permission;
        }
    }
};

const actions = {
    load({commit}){
        return axios.get('/permissions').then(response => commit('load', response.$data));
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
